import axios from "axios";
const token = window.localStorage.getItem("token");
const state = {
  websites: [],
};
const getters = {
  GetWebsite: state => state.websites,
};
const actions = {
  async createWebsite({ commit },payload) {
    let response = await axios.post('card/website',payload)
    commit('setWebsiteData', response.data.data)
  },
  async deleteWebsite({ commit },payload) {
    let response = await axios.post('card/website/delete',payload)
    commit('setWebsiteData', response.data.data)
  },
};
const mutations = {
    setWebsiteData(state, websiteData) {
        state.websites = websiteData ;
      }
};
export default {
  namespaced: true,
  state,
  getters,
  actions,
  mutations,
};
